export default __webpack_public_path__ + "static/media/Level8.955b1ff7.svg";